import { takeEvery, put, call } from "redux-saga/effects"

//Account Redux states
import { UNLOCK_ACCOUNT_ADMIN_USER, UNLOCK_TOKEN_ADMIN_USER } from "./actionTypes";
import { unlockAccountAdminUserSuccess, unlockAccountAdminUserError, unlockTokenAdminUserSuccess, unlockTokenAdminUserError } from "./actions";

import { AppConfiguration } from "config";

import { postJwtRegister, genericGetRequest } from "helpers/sf_backend_helper";
import ToastAlert from "components/Common/ToastAlert/ToastAlert";

// Is user register successfull then direct plot user in redux.
function* UnlockAccount(action) {
  try {
    const response = yield call(
      postJwtRegister,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_unlock`,
      {...action.payload})
    ToastAlert.fire({icon: "success", title: "Unlock instructions have been sent to the email address registered with the account."})
    yield put(unlockAccountAdminUserSuccess(response))
  } catch (error) {
    yield put(unlockAccountAdminUserError(error))
  }
}

function* UnlockToken({ payload: { user, history } }) {
  try {
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_unlock`,
      user)
    yield put(unlockTokenAdminUserSuccess(response))

    history.push("/login?flash_message_type=success&flash_message_text=Unlock successful, please login to proceed.")
  } catch (error) {
    yield put(unlockTokenAdminUserError(error))
  }
}

export function* UnlockAdminUserSaga() {
  yield takeEvery(UNLOCK_ACCOUNT_ADMIN_USER, UnlockAccount)
  yield takeEvery(UNLOCK_TOKEN_ADMIN_USER, UnlockToken)
}

export default UnlockAdminUserSaga;
